import Vue from 'vue';

import InlineAds from '../../components/components.inline-ads.vue';

Vue.component('forms', {
    components: {
        InlineAds
    },
    data () {
        return {
            targetedAds: window.immiObj.targetedAds
        }
    }
})